import BASEURLZAI from '../api/zai'

export function buscarChat(idChat: string) {
    return BASEURLZAI.get(`/ticket/chat/${idChat}`)
}

export function atualizarMsgLidaSite(idChat: string) {
    return BASEURLZAI.put(`/chat/msg/site/lida/${idChat}`)
}